import React from 'react';
import './styles/responsive.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Projects from './pages/Projects';
import WorkOrders from './pages/WorkOrders';
import Users from './pages/Users';
import Equipment from './pages/Equipment';
import MaintenanceReports from './pages/MaintenanceReports';
import MaintenanceOrders from './pages/MaintenanceOrders';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Rutas públicas */}
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Navigate to="/login" />} />

          {/* Rutas Protegidas */}
          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/equipment" element={<Equipment />} />
            <Route path="/work-orders" element={<WorkOrders />} />            
            <Route path="/maintenance-reports" element={<MaintenanceReports />} />
            {/* Órdenes de mantenimiento: planificación y seguimiento de mantenimientos */}
            <Route path="/maintenance-orders" element={<MaintenanceOrders />} />
            {/* Gestión de usuarios: accesible solo para ADMIN y SUPERVISOR */}
            <Route
              path="/users"
              element={
                <ProtectedRoute allowedRoles={['ADMIN', 'SUPERVISOR']}>
                  <Users />
                </ProtectedRoute>
              }
            />
            {/* Registro de usuario: flujo interno restringido exclusivamente al ADMIN */}
            <Route
              path="/register"
              element={
                <ProtectedRoute allowedRoles={['ADMIN']}>
                  <Register />
                </ProtectedRoute>
              }
            />
          </Route>

          {/* Opcional: Ruta para manejar 404 */}
          <Route path="*" element={<div>404 Not Found</div>} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
